var _circle, _circle2, _circle3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "#65AAE0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    fill: "url(#paint0_radial_2219_29193)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "url(#paint1_linear_2219_29193)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9869 21.6215C13.8674 21.2825 13.8076 20.8776 13.8076 20.4068C13.8076 19.6911 13.8973 19.0697 14.0765 18.5424C14.2557 18.0151 14.4747 17.5348 14.7336 17.1017C14.9924 16.6497 15.2812 16.226 15.5998 15.8305C15.9184 15.4162 16.2071 14.9736 16.466 14.5028C16.7248 14.032 16.9438 13.5047 17.1231 12.9209C17.3023 12.3183 17.3919 11.6026 17.3919 10.774C17.3919 10.0584 17.2425 9.55932 16.9438 9.27684C16.6651 8.97552 16.2668 8.82486 15.7491 8.82486C15.2314 8.82486 14.8232 8.97552 14.5245 9.27684C14.2457 9.55932 14.1063 10.0584 14.1063 10.774V12.9209H11V10.9718C11 9.371 11.3982 8.14689 12.1947 7.29943C13.0112 6.43314 14.2258 6 15.8387 6C17.4516 6 18.6563 6.43314 19.4528 7.29943C20.2692 8.14689 20.6774 9.371 20.6774 10.9718C20.6774 11.838 20.5779 12.5913 20.3787 13.2316C20.1995 13.8531 19.9606 14.4181 19.6619 14.9266C19.3831 15.435 19.0745 15.9058 18.736 16.339C18.3975 16.7533 18.0789 17.1676 17.7802 17.5819C17.5014 17.9962 17.2624 18.4388 17.0633 18.9096C16.8841 19.3804 16.7945 19.9171 16.7945 20.5198C16.7945 20.9341 16.8343 21.3013 16.914 21.6215H13.9869ZM17.0036 23.0056V26H13.8375V23.0056H17.0036Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2219_29193",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.7586 32) rotate(-90.155) scale(34.0001 18.4125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65AAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026ABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2219_29193",
    x1: 16.5977,
    y1: -5.78948e-7,
    x2: 35.2462,
    y2: 16.4025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#468ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#026BBD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.0304d9a9.svg";
export { ForwardRef as ReactComponent };